// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__2I-g8","busy":"button_busy__31hdP","isBusy":"button_isBusy__AVAJL"};